module.exports = __webpack_public_path__ + "img/2.427e9aa2.png";